// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
* Any place that links exist directly under the page tilte (e.g.: messages/inbox/, under title of Messages, two links exist.
* This area corresponds to that styling
*/
.subLinkHeader {
  border-bottom: 1px solid #e5e5e5;
  margin: 0 -15px 15px;
}

.subLinkHeader ul {
  margin: 15px;
  padding: 0px;
}

.subLinkHeader ul li {
  display: inline-block;
  margin-right: 15px;
}

.subLinkHeader ul li:not(:last-child):after {
  content: '|';
  padding-left: 15px;
}

.subLinkHeader ul li a.active {
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/navigations.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["/**\n* Any place that links exist directly under the page tilte (e.g.: messages/inbox/, under title of Messages, two links exist.\n* This area corresponds to that styling\n*/\n.subLinkHeader {\n  border-bottom: 1px solid #e5e5e5;\n  margin: 0 -15px 15px;\n}\n\n.subLinkHeader ul {\n  margin: 15px;\n  padding: 0px;\n}\n\n.subLinkHeader ul li {\n  display: inline-block;\n  margin-right: 15px;\n}\n\n.subLinkHeader ul li:not(:last-child):after {\n  content: '|';\n  padding-left: 15px;\n}\n\n.subLinkHeader ul li a.active {\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
